import apiCaller from "./axios.service";

const baseUrl: string = "/v1/public/public";

export const getProvider = async <T>(
	provider_category: string,
	provider_type: string
): Promise<T> => {
	return apiCaller(`${baseUrl}/getProvider`, {
		provider_category,
		provider_type,
	});
};

export const getProviderCategory = async <T>(): Promise<T> => {
	return apiCaller(`${baseUrl}/getProviderCategory`);
};

export const getProviderApp = async <T>(): Promise<T> => {
	return apiCaller(`${baseUrl}/getProviderApp`);
};

export const getSupportSetting = () => {
	return apiCaller(`${baseUrl}/getSupportSetting`);
};

export const getAnnouncement = (announcement_tier?: string) => {
	return apiCaller(`${baseUrl}/getAnnouncement`, { announcement_tier });
};

export const getPopoutAnnouncement = () => {
	return apiCaller(`${baseUrl}/getPopoutAnnouncement`);
};

export const getLobbyPromotion = () => {
	return apiCaller(`${baseUrl}/getLobbyPromotion`);
};

export const getLatestPlayerToken = async <T>(token: any): Promise<T> => {
	return apiCaller(`${baseUrl}/getLatestPlayerToken`, {
		token,
	});
};

export const getClientTheme = () => {
	return apiCaller(`${baseUrl}/getClientTheme`);
}